<template>
  <v-form>
    <v-card class="reschedule">
      <v-card-title>{{ $t("page.profile.reschedule_book") }}</v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <p class="mb-0">*{{ $t("field.rules_rescheduled") }}</p>
            <p class="mb-0">
              *{{ $t("field.max_rescheduled_company") }}
              {{ data.max_reschedule }} {{ $t("field.times") }}
            </p>
            <p
              v-if="data.reschedule_allowed < data.max_reschedule"
              class="mb-0"
            >
              *{{ $t("field.attemp_rescheduled") }}
              <b>
                {{ data.max_reschedule - data.reschedule_allowed }}
              </b>
              {{ $t("field.times") }}
            </p>
          </v-col>
          <v-col cols="12">
            <!-- <v-select
              :items="branch"
              ref="branch"
              :label="$t('field.branch')"
              item-text="name"
              item-value="id"
              v-model="payload.branch"
              dense
              outlined
              :rules="[v => !!v || `${$t('field.branch')} ${$t('is_required')}`]"
            ></v-select> -->

            <v-text-field
              v-model="bookingHomecare"
              ref="booking_date"
              :label="$t('field.booking_date')"
              outlined
              append-icon="mdi-calendar-range"
              dense
              readonly
              @click.stop="openDatepicker = true"
              :rules="[
                v => !!v || `${$t('field.booking_date')} ${$t('is_required')}`,
              ]"
            ></v-text-field>
            <!-- <c-datepicker
                :plant="payload.branch"
                checkQueue
                :minDate="minDate"
                :maxDate="maxDate"
                :value="payload.booking_date"
                :holiday="getHoliday"
                :enableDays="getEnableDays"
                @changeValue="payload.booking_date = $event"
                @change="opendatepicker = false"
              ></c-datepicker> -->
            <!-- <date-home-care
                :value="data.booking_date"
                :plant="data.plant_id"
                :plantHoliday="findPlant(data.plant_id).upcoming_holidays"
                reschedule
                @toggleModal="dialog_reschedule_homecare = !dialog_reschedule_homecare"
                @changeTime="time => changeTime(time)"
              >
              </date-home-care> -->
            <div class="d-flex justify-end">
              <!-- <c-button
                class="mx-2 py-2"
                rounded
                outline
                @click="$emit('closeReschedule')"
                >{{ $t("cancel") }}</c-button
              > -->
              <c-button
                class="mx-2 py-2"
                roundedSmall
                :disabled="disabledSave"
                @click="saveReschedule()"
                >{{ $t("save") }}</c-button
              >
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-dialog
      v-model="openDatepicker"
      v-if="openDatepicker"
      max-width="450px"
      content-class="modal-schedule"
      @click:outside="openDatepicker = false"
    >
      <date-home-care
        :minDate="minDate"
        :maxDate="maxDate"
        :value="payload.dateBooking"
        :plant="data.plant_id"
        :holiday="getHoliday"
        :enableDays="getEnableDays"
        @changeTime="time => changeTime(time)"
      ></date-home-care>
    </v-dialog>
  </v-form>
</template>

<script>
import API from "@/service/api_service";
import Auth from "@/service/auth_service";
import CButton from "@/components/v2/button/index.vue";
import moment from "moment-timezone";
import DateHomeCare from "@/components/v3/date/dateHomeCare.vue";

export default {
  components: {
    CButton,
    DateHomeCare,
  },
  data: () => ({
    branch: [],
    disabledSave: true,
    payload: {
      booking_date: "",
      branch: "",
      dateBooking: "",
      timeBooking: {},
    },
    opendatepicker: false,
    formHasErrors: false,
    openDatepicker: false,
    // start available date
    availableDates: [],
    // end available date
  }),
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  watch: {
    "payload.dateBooking": function () {
      this.disabledSave = moment(this.data.booking_date).isSame(
        this.payload.dateBooking
      );
    },
  },
  computed: {
    bookingHomecare() {
      return this.payload.dateBooking
        ? moment(this.payload.dateBooking).format("HH:mm, DD-MMM-YYYY")
        : "";
    },
    // start reschedule data
    getDataReschedule() {
      return this.$store.state.rescheduleData;
    },
    // end reschedule data
    // start holiday
    getHoliday() {
      return this.getDataPlant ? this.getDataPlant.upcoming_holidays : [];
    },
    // end holiday

    // start enable days
    getEnableDays() {
      let enableDays = [];
      const days = [
        "Minggu",
        "Senin",
        "Selasa",
        "Rabu",
        "Kamis",
        "Jumat",
        "Sabtu",
      ];
      const { opening_hours } = !this.getDataPlant || this.getDataPlant;
      for (let i = 0; i < days.length; i++) {
        const indexDays =
          opening_hours == undefined
            ? -1
            : opening_hours.findIndex(item => item.day == days[i]);
        if (indexDays > -1) {
          enableDays.push(i);
        }
      }
      return enableDays;
    },
    // end enable days
    // start get plant detail
    getDataPlant() {
      const indexPlant = this.branch.findIndex(
        item => item.id == this.data.plant_id
      );
      if (indexPlant > -1) {
        return this.branch[indexPlant];
      }
      return null;
    },
    // end get plant detail

    minDate() {
      // Set the start and end time boundaries
      if (this.getDataPlant) {
        let currentTime = moment();
        if (currentTime.isBefore(this.data.booking_date))
          return this.calculateMinReschedule(
            this.data.booking_date,
            this.getDataReschedule.expired_days_before
          );
        const timezone = moment.tz.guess();
        if (this.getDataPlant.timezone_area == timezone) {
          currentTime = moment();
        } else {
          const now = moment().format("HH:mm:ss");
          currentTime = moment(
            this.convertTime(
              now,
              moment.tz.guess(),
              this.getDataPlant.timezone_area
            ),
            "YYYY-MM-DD HH:mm:ss"
          );
        }
        let startTime = "";
        let endTime = "";
        const { opening_hours } = this.getDataPlant;
        const indexByDayName = opening_hours.findIndex(
          item => item.day == currentTime.locale("ID").format("dddd")
        );
        if (indexByDayName > -1) {
          const close = opening_hours[indexByDayName].hours
            .split("-")[1]
            .replace(":00", "");
          startTime = moment()
            .hour(0) // mulai jam 00:00
            .minute(0)
            .second(0);
          endTime = moment().hour(close).minute(0).second(0);
        }
        // Check if the current time is between the start and end time
        const isWithinTimeRange = currentTime.isBetween(startTime, endTime);
        // Output the result
        let found = false;
        let i = !isWithinTimeRange ? 2 : 1;
        while (!found) {
          let date = moment().add(i, "days");
          if (
            this.holiday.findIndex(item => date.isSame(item.date, "day")) < 0 &&
            this.getEnableDays.includes(date.day())
          ) {
            found = true;
          } else {
            found = false;
            i++;
          }
        }
        return moment().add(i, "days").format("YYYY-MM-DD");
      }
      return moment().format("YYYY-MM-DD");
    },
    maxDate() {
      if (this.getDataPlant) {
        const bookingTime = moment(
          this.calculateMaxReschedule(
            this.data.booking_date,
            this.getDataReschedule.expired_days
          )
        );
        return bookingTime.format("YYYY-MM-DD");
      }
      return null;
    },
    form() {
      return {
        booking_date: this.payload.dateBooking,
        // branch: this.payload.branch,
      };
    },
  },
  created() {
    this.getPlant();
    this.payload.dateBooking = this.data.booking_date;
    this.payload.branch = this.data.plant_id;
  },
  methods: {
    // start change time datepicker
    changeTime(time) {
      this.openDatepicker = false;
      this.payload.timeBooking = {
        start_at: moment(time).format("YYYY-MM-DD HH:mm:ss"),
      };
      this.payload.dateBooking = time;
    },
    // end change time datepicker

    // check holiday
    checkIsHoliday(param) {
      const date = moment(param);
      return this.getHoliday.some(holiday => date.isSame(holiday.date));
    },
    // start calculate reschedule min
    calculateMinReschedule(date, min) {
      const initialDate = moment(date);
      let excMin = 0;
      while (min > excMin) {
        initialDate.subtract(1, "days");
        if (
          !this.checkIsHoliday(initialDate) &&
          this.getEnableDays.includes(initialDate.day())
        ) {
          excMin++;
        }
      }
      return initialDate.format("YYYY-MM-DD");
    },
    // end calculate reschedule min
    // start calculate reschedule max
    calculateMaxReschedule(date, max) {
      const initialDate = moment(date);
      let excMax = 0;
      while (max > excMax) {
        initialDate.add(1, "days");
        if (
          !this.checkIsHoliday(initialDate) &&
          this.getEnableDays.includes(initialDate.day())
        ) {
          excMax++;
        }
      }
      return initialDate.format("YYYY-MM-DD");
    },
    // end calculate reschedule max

    // start available date
    allowedDates(a) {
      return this.availableDates.includes(a);
    },
    pickerUpdate: function (val) {
      let totalDay = moment(val, "YYYY-MM").daysInMonth();

      let availableDates = [];

      let monthNow = moment().format("M");
      let monthSelected = moment(val).format("M");
      let day;

      if (monthNow == monthSelected) day = moment().format("D");
      else day = 1;

      for (let i = day; i <= totalDay; i++) {
        let date = moment()
          .month(val.split("-")[1] - 1)
          .date(i)
          .format("YYYY-MM-DD");
        if (moment(date).day() !== 0) availableDates.push(date);
      }
      this.availableDates = availableDates;
      this.allowedDates();
    },
    // end available date

    async dateDiffInDays(a, b) {
      const _MS_PER_DAY = 1000 * 60 * 60 * 24;
      // Discard the time and time-zone information.
      const utc1 = new Date(a.getFullYear(), a.getMonth(), a.getDate());
      const utc2 = new Date(b.getFullYear(), b.getMonth(), b.getDate());

      return Math.floor((utc2 - utc1) / _MS_PER_DAY);
    },
    async saveReschedule() {
      this.formHasErrors = false;
      Object.keys(this.form).forEach(f => {
        if (!this.form[f]) this.formHasErrors = true;
        this.$refs[f].validate(true);
      });
      if (!this.formHasErrors) {
        try {
          const dataReady = [
            {
              registration_group: this.data.registration_group,
              address: this.data.sample_pickup_location,
              date: this.payload.dateBooking,
            },
          ];
          const resp = await API.post(
            `${this.$apiUrl.reschedule}-homecare`,
            {
              "Content-Type": "application/json",
              Authorization: `Bearer ${Auth.getToken()}`,
            },
            dataReady
          );
          if (resp.statusCode == 200) {
            this.toast("success", this.$t("success_reschedule"));
            this.$emit("updateData");
            // this.payload = { booking_date: "", branch: "" };
            this.$emit("closeReschedule");
          } else {
            this.$swal({
              icon: "error",
              text: this.$t("error_reschedule"),
            });
          }
        } catch (error) {
          console.log(error);
        }
      }
    },
    toast(status, messages) {
      this.$swal
        .mixin({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          didOpen: toast => {
            toast.addEventListener("mouseenter", this.$swal.stopTimer);
            toast.addEventListener("mouseleave", this.$swal.resumeTimer);
          },
        })
        .fire({
          icon: status,
          title: messages,
        });
    },
    formatDate(date) {
      return moment(date).locale(this.$i18n.locale).format("DD-MMM-YYYY");
    },
    async getPlant() {
      const resp = await API.get(
        `${this.$apiUrl.getPlant}?show_opening_hours=true`,
        {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Auth.getToken()}`,
        }
      );
      if (resp.statusCode == 200) {
        this.branch = resp.results;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.rechedule {
  background: white;
}
</style>
